export const SDK_NAME = 'MITO.browser'
// export const SDK_VERSION = process.env.npm_package_version
export const SDK_VERSION = '1.0.0'
export const SERVER_URL = '//localhost:3000/api/error/error.gif'
